<template>
    <section class="body">
        <ExportDialog @ok="selectExportMode" :dialogId="exportDialogId" getter="getProgramsExportQuery" setter="setProgramsExportQuery" />
        <div v-if="programsInitStatus == 'LOADING'">
            <div v-if="loadingFormData" class="text-center mb-2">
                <b-progress :value="loadingFormDataValue" show-progress class="m-5" />
            </div>
        </div>
        <div class="failedRequest" v-if="programsInitStatus == 'FAILED'">Cannot return result because of server error.</div>
        <div v-if="programsInitStatus == 'LOADED'">
            <b-form>
                <b-form-row class="justify-content-center">
                    <DateModalProgram :fieldData="formFields.date" :latestDate="$store.getters.getPublishedToDate" @onInputChanged="inputChanged" />
                    <ProviderPickerProgramsAdsModal :fieldData="formFields.providers" getter="getProgramsQuery" providersSetter="setProgramsQueryProviders" setter="setProgramsQuery" />
                    <TargetGroupPrograms :fieldData="formFields.target_group" getter="getProgramsQuery" setter="setProgramsQuery" />
                    <TitleModal :fieldData="formFields.title" />
                    <WeekdaysBubble :fieldData="formFields.weekdays" getter="getProgramsQuery" setter="setProgramsQuery" />
                    <GenrePickerModal :fieldData="formFields.genres" getter="getProgramsQuery" setter="setProgramsQuery" />
                    <StartTimeBubbleTv :fieldData="formFields.start_time_tv" getter="getProgramsQuery" setter="setProgramsQuery"  />
                    <CountryTargetBubble :fieldData="formFields.countryTarget" getter="getProgramsQuery" setter="setProgramsQuery" />
                    <ToggleButton :fieldData="formFields.show_all_content_with_traffic_in_period" getter="getProgramsQuery" setter="setProgramsQuery" />
                    <CheckboxDropdownColumns :fieldData="columnsField" getter="getProgramsQuery" setter="setProgramsQuery"  />
                </b-form-row>
                <b-form-row class="mb-2 justify-content-center">
                    <button v-if="getSelectedInputs > 0" type="button" class="trashbtn mt-2 mr-2" @click="clearAllFields">
                        <b-icon-trash />
                    </button>
                    <div v-for="(selectedButton, key) in selectedBtns" :key="key">
                        <button class="selectedbtns mr-2 mt-2 bubblefontsize" type="button" @click="selectedButton.clickedBtn && selectedButton.clickedBtn()">
                            <span v-html="selectedButton.text" />
                            <b-icon
                                v-if="selectedButton.editable"
                                class="ml-2 crossbtn"
                                font-scale="1.5"
                                icon="x"
                                @click="selectedButton.clickedBtnDelete && selectedButton.clickedBtnDelete($event)"
                            />
                        </button>
                    </div>
                </b-form-row>
                <div v-if="!TargetGroupExists">
                    <div class="text-center mb-2">
                        <div>
                            <small class="text-danger"><strong>You need to choose measure under Targetgroups / Measures </strong></small>
                        </div>
                    </div>
                </div>
                <b-form-row class="mb-2 justify-content-center">
                    <div>
                        <b-button :disabled="disableRunBtn" @click="submitSearch" class="searchbutton" variant="primary" size="sm">
                            <font-awesome-icon v-if="status != 'LOADING' && !loadingExportResults" style="font-size: 1rem; position: relative; top: 1px; right: 2px;" :icon="['fas', 'play']" />
                            {{ status === "LOADING" ? "Working..." : "Run" }}
                        </b-button>
                    </div>
                </b-form-row>
            </b-form>
            <div v-if="exceededConsumptionPeriodLimitAndReachSelected && config_ShowConsumtionPeriodProgram">
                <div class="text-center mb-2">
                    <div>
                        <small class="text-danger"
                            ><strong>You can max choose {{ config_NumberOfConsumptionDaysProgram }} days as consumtionperiod for measure Reach.</strong></small
                        >
                    </div>
                </div>
            </div>
            <ConfirmDialog
                @cancel="onCancelDialog"
                dialogTitle="Recommendation for analyses"
                :dialogMessage="messageExceededRecommendedPeriod"
                :dialogId="exceededRecommendedPeriodDialogId"
                :dialogVerticalCenter="true"
            >
                <template v-slot:modal-footer>
                    <b-button size="sm" variant="outline-secondary" @click="onCancelDialog">
                        Cancel
                    </b-button>
                    <b-button size="sm" variant="primary" @click="acceptExceededRecommendedPeriod">
                        Ok
                    </b-button>
                </template>
            </ConfirmDialog>
        </div>
        <hr />

        <b-tabs content-class="mt-3" v-model="tabIndex" @activate-tab="handleTabActivation">
            <b-tab title="List">
                <Spinner v-if="status == 'LOADING'" loadingMsg="Loading results..." />
                <div v-else-if="status == 'EMPTY_RESULT'">No results found for the current search</div>
                <div v-else-if="status == 'LOADED'">
                    <ResultTableMainProgram :sortBy.sync="mainSortBy" :sortDesc.sync="mainSortDesc" />
                </div>
                <div class="failedRequest" v-else-if="status == 'FAILED'">Cannot return result because of server error.</div>
                <div v-else-if="status == 'VALIDATION_FAILED'" class="text-danger">
                    <span v-bind:key="index" v-for="(error, index) in formErrors" class="d-block">
                        {{ error }}
                    </span>
                </div>
            </b-tab>
            <b-tab v-if="config_ShowReachFrequencyProgram" :title="rofTabTitle" :disabled="!this.$store.getters.getProgramsHaveSelectedRow || !TargetGroupExists">
                <ProgramReach
                    :showTableDetails="showTableDetails"
                    :exceededRecommendedPeriodLimit="exceededRecommendedPeriodLimit"
                    :isShowDetailsBtnVisible="isShowDetailsBtnVisible"
                    :tabIndex="tabIndex"
                    @onUpdateRoF="updateRoF($store.getters.getProgramsRoFQuery.hasAdjustedTime)"
                    @onShowTableDetails="showTableDetails = $event"
                    @onShowDetailsBtnVisible="isShowDetailsBtnVisible = $event"
                ></ProgramReach>
            </b-tab>
            <template v-slot:tabs-end>
                <div class="ml-auto">
                    <b-button class="mb-2 align-baseline mr-2" size="sm" variant="primary" @click="showOrHideSumInTable" :disabled="disableSumBtn" v-if="showSumBtn"
                        >{{ sumVisible ? "Hide summary" : "Show summary" }}
                    </b-button>
                    <b-button
                        :disabled="loadingExportResults"
                        class="ml-auto"
                        size="sm"
                        variant="success"
                        @click="userClickedExport"
                        v-if="status === 'LOADED'"
                        v-b-tooltip.hover
                        title="Export result on screen"
                    >
                        <font-awesome-icon style="font-size: 1rem; position: relative; top: 1px; right: 2px;" :icon="['fas', 'file-export']" />
                        {{ loadingExportResults ? "Working..." : "Export" }}
                    </b-button>
                </div>
            </template>
            <SlowQueryModal :show="showSlowQueryModal" :loading="loadingExportResults" @download="handleDownloadSlowQueryModal" @cancel="handleCancelSlowQueryModal" />
            <ScheduleReportModal :show="showScheduleReportModal" :loading="loadingScheduleReport" @submit="handleScheduleReportSubmit" @cancel="handleScheduleReportCancel" />
        </b-tabs>
    </section>
</template>

<script>
import SlowQueryModal from "../../Shared/SlowQueryModal/SlowQueryModal.vue"
import ScheduleReportModal from "../../Shared/ScheduleReportModal/ScheduleReportModal.vue"
import DateModalProgram from "./DateModalProgram"
import TitleModal from "./TitleModal"
import WeekdaysBubble from "../../Shared/FormElement/CheckboxDropdown/WeekdaysBubble"
import StartTimeBubbleTv from "./StartTimeBubbleTv"
import ProgramReach from "@/components/Layout/Programs/ProgramReach"
import Spinner from "@/components/Shared/Spinner/Spinner"
import { baseFields } from "./formData"
import { validationRules } from "./programValidationRules"
import inputValidation from "@/mixins/inputValidation"
import { mapState } from "vuex"
import * as Actions from "@/store/modules/programs/action-types"
import * as Mutations from "@/store/modules/programs/mutation-types"
import * as Helpers from "@/helpers"
import { download, dateToyymmddFormat, scrollToBottom, daysBetweenDates } from "../../../api/utils.js"
import dayjs from "dayjs"
import ResultTableMainProgram from "@/components/Layout/Programs/ResultTableMainProgram"
import ExportDialog from "@/components/Shared/FormElement/Dialogs/ExportDialog"
import globalConfig from "../../../mixins/globalConfig"
import ConfirmDialog from "@/components/Shared/FormElement/Dialogs/ConfirmDialog"
import ProviderPickerProgramsAdsModal from "../../Layout/Programs/ProviderPickerProgramsAdsModal.vue"
import GenrePickerModal from "../../Shared/FormElement/GenrePicker/GenrePickerModal.vue"
import ToggleButton from "../../Shared/FormElement/ToggleButton/ToggleButton.vue"
import CheckboxDropdownColumns from "../../Shared/FormElement/CheckboxDropdown/CheckboxDropdownColumns.vue"
import TargetGroupPrograms from "../../Shared/FormElement/TargetGroup/TargetGroupPrograms"
import CountryTargetBubble from "./CountryTargetBubble";

export default {
    name: "Programs",
    components: {
        SlowQueryModal,
        ScheduleReportModal,
        ProgramReach,
        Spinner,
        ResultTableMainProgram,
        ExportDialog,
        ConfirmDialog,
        DateModalProgram,
        TitleModal,
        WeekdaysBubble,
        CountryTargetBubble,
        StartTimeBubbleTv,
        ProviderPickerProgramsAdsModal,
        GenrePickerModal,
        TargetGroupPrograms,
        ToggleButton,
        CheckboxDropdownColumns,
    },
    mixins: [inputValidation, globalConfig],
    data() {
        return {
            showScheduleReportModal: false,
            loadingScheduleReport: false,
            showSlowQueryModal: false,
            filterRatingIsChecked: false,
            loadingFormData: true,
            loadingFormDataValue: 0,
            formFields: baseFields,
            loadingExportResults: false,
            columnsField: {
                config: { options: [] },
                identifier: "columns",
                label: "Show columns",
            },
            selectAll: false,
            calledGetChannels: false,
            calledGetProviders: false,
            tabName: "list",
            targetLabel: "",
            message: "",
            formErrors: [],
            tabIndex: 0,
            contentKeys: {
                programs: "",
                showConsumtionPeriodProgram: "",
            },
            exportDialogId: "programs-export-modal",
            exceededRecommendedPeriodDialogId: "exceeded-recommended-period",
            mainSortBy: "measure_1",
            mainSortDesc: true,
            hasAcceptedExceededPeriod: false,
            seeOldDataDialogId: "see-old-data",
            isShowDetailsBtnVisible: false,
            messageExceededRecommendedPeriod: "",
            showTableDetails: false,
            checkForFieldChanges: false,
            selectedBtns: [],
        }
    },
    beforeDestroy() {
        document.removeEventListener("keyup", this.onKeyUp)
    },
    watch: {
        "$store.getters.getProgramsQueryCost.data"(queryData) {
            // show modal
            if (queryData.queryClass == "RowLimitExceeded") {
                this.showSlowQueryModal = true
            }
            if (queryData.queryClass == "Schedule") {
                this.showScheduleReportModal = true
            }
            if (queryData.queryClass == "Forbidden") {
                this.$bvToast.toast("The query is too demanding. Please narrow the search or remove target groups.", {
                    title: "Server Error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000,
                })
            }
        },
        "$store.getters.getPublishedToDate"(publishedToDate) {
            this.setStartAndEndDate(publishedToDate)
        },
        "$store.getters.getProgramsQuery": {
            deep: true,
            handler(query) {
                this.resetFailedOrEmptyState()
                let selectedBtns = []
                selectedBtns.push({
                    text: `<span class="font-weight-bold">Consumption Date:</span> ${query.start_date} - ${query.end_date}`,
                    editable: false,
                    clickedBtn: () => {
                        this.formFields.date.showDateModal = true
                    },
                })
                if (query.searchForPubDate)
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">Publication Date:</span> ${query.pub_start_date} - ${query.pub_end_date}`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.date.showDateModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.query.searchForPubDate = false
                            this.query.pub_start_date = ""
                            this.query.pub_end_date = ""
                            this.query.target_group = []
                        },
                    })
                if (query.provider_keys.length > 0) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">Channels:</span> ${query.provider_keys.length} selected`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.providers.showChannelModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.query.provider_keys = []
                        },
                    })
                }
                let numberOfStoredTargets = query.target_group.length
                if (numberOfStoredTargets > 0) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">Targets / Measures:</span> ${numberOfStoredTargets} selected`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.target_group.showTargetGroupModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.removeTargets()
                        },
                    })
                }
                if (query.title) {
                    let titleText = `<span class="font-weight-bold">Title:</span> ${query.title}`
                    if (titleText.length > 70) titleText = titleText.substring(0, 70) + "..."
                    selectedBtns.push({
                        text: titleText,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.title.showTitleModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            let updatedQuery = {
                                ...this.$store.getters["getProgramsQuery"],
                                title: "",
                            }
                            this.$store.commit("setProgramsQuery", updatedQuery)
                        },
                    })
                }
                if (query.weekdays.length > 0) {
                    let chosenText = "selected";
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">Weekday TV:</span> (${query.weekdays.length} ${chosenText})`,
                        editable: true,
                    clickedBtn: () => {
                        this.formFields.weekdays.showWeekdayModal = true;
                    },
                    clickedBtnDelete: event => {
                        event.stopPropagation();
                        let updatedQuery = {
                        ...this.$store.getters["getProgramsQuery"],
                        weekdays: []
                        };
                        this.$store.commit("setProgramsQuery", updatedQuery);
                    }
                    });
                }
                let numberOfStoredGenres = query.genres.genres.length
                if (numberOfStoredGenres > 0) {
                    selectedBtns.push({
                        text: `<span class="font-weight-bold">Genre:</span> ${numberOfStoredGenres} selected`,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.genres.showGenreModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            this.removeGenres()
                        },
                    })
                }
                if (query.start_time_tv) {
                    let startTimeText = `<span class="font-weight-bold">Start Time TV:</span> ${query.start_time_tv}`
                    selectedBtns.push({
                        text: startTimeText,
                        editable: true,
                        clickedBtn: () => {
                            this.formFields.start_time_tv.showStartTimeTvModal = true
                        },
                        clickedBtnDelete: event => {
                            event.stopPropagation()
                            let updatedQuery = {
                                ...this.$store.getters["getProgramsQuery"],
                                start_time_tv: "",
                            }
                            this.$store.commit("setProgramsQuery", updatedQuery)
                        },
                    })
                }
                let numberOfCountryTargets = query.countryTargetGroups.length;
                if (numberOfCountryTargets > 0) {
                    let chosenText = "selected"
                    let countryTargetsText = `<span class="font-weight-bold">Country of production / Main target group:</span> ${numberOfCountryTargets} ${chosenText}`;
                    selectedBtns.push({
                    text: countryTargetsText,
                    editable: true,
                    clickedBtn: () => {
                        this.formFields.countryTarget.showCountryTargetModal = true;
                    },
                    clickedBtnDelete: event => {
                        event.stopPropagation();
                        let updatedQuery = {
                        ...this.$store.getters["getProgramsQuery"],
                        countryTargetGroups: []
                        };
                        this.$store.commit("setProgramsQuery", updatedQuery);
                    }
                    });
                }
                let emptyAnswer = query.show_all_content_with_traffic_in_period
                let yesOrNo = emptyAnswer ? "yes" : "no"
                selectedBtns.push({
                    text: `<span class="font-weight-bold">Show empty responses:</span> ${yesOrNo}`,
                    editable: false,
                    clickedBtn: () => {
                        this.query.show_all_content_with_traffic_in_period = !this.query.show_all_content_with_traffic_in_period
                    },
                })
                this.selectedBtns = selectedBtns
            },
        },
        tabIndex(newVal) {
            if (newVal === 0) {
                this.hasAcceptedExceededPeriod = false
            }
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        this.init()
        let customParseFormat = require("dayjs/plugin/customParseFormat")
        dayjs.extend(customParseFormat)
    },
    computed: {
        showSumBtn() {
            let showSumBtn = false
            if (this.$store.getters.getProgramsResults.status == "LOADED" && this.tabName === "list") {
                showSumBtn = true
            }
            return showSumBtn
        },
        sumVisible() {
            let sumVisible = false
            if (this.status === "LOADED") {
                sumVisible = this.$store.getters.getProgramsSumVisible
            }
            return sumVisible
        },
        disableSumBtn() {
            let disableSumBtn = false
            if (this.$store.getters.getProgramsHasExcludedRow) disableSumBtn = true
            return disableSumBtn
        },
        allModalsClosed() {
            let allModalsClosed = false
            if (
                !this.formFields.date.showDateModal &&
                !this.formFields.genres.showGenreModal &&
                !this.formFields.providers.showChannelModal &&
                !this.formFields.target_group.showTargetGroupModal &&
                !this.formFields.title.showTitleModal &&
                !this.formFields.start_time_tv.showStartTimeTvModal &&
                !this.formFields.weekdays.showWeekdayModal &&
                !this.formFields.countryTarget.showCountryTargetModal
            )
                allModalsClosed = true
            return allModalsClosed
        },
        rofTabTitle() {
            let rofTabTitle = "Reach and Frequency"
            if (!this.TargetGroupExists) rofTabTitle += " (target group must be specified)"
            return rofTabTitle
        },
        disableRunBtn() {
            let disableRunBtn = false
            if (this.status == "LOADING" || this.$store.getters.getProgramsQuery.columns.length == 0 || !this.TargetGroupExists || this.exceededConsumptionPeriodLimitAndReachSelected)
                disableRunBtn = true
            return disableRunBtn
        },
        getSelectedInputs() {
            let selectedInputs = this.selectedBtns.length
            return selectedInputs
        },
        programsExportQuery() {
            return this.$store.getters.getProgramsExportQuery
        },
        result() {
            return this.$store.getters.getProgramsResults
        },
        status() {
            return this.$store.getters.getProgramsResults.status
        },
                    // some state from vuex
        ...mapState({
            programsInitStatus: ({ programs }) => programs.programsInitStatus,
            query: ({ programs }) => programs.programsQuery,
        }),
        TargetGroupExists() {
           let targetGroup = this.$store.getters.getProgramsQuery.target_group
           if (targetGroup.length > 0) {
            return true
           } else {
            return false
           }
        },
        exceededConsumptionPeriodLimitAndReachSelected() {
            let isConsumptionPeriodLimitExceededAndReachSelected = false
            let targetGroup = this.$store.getters.getProgramsQuery.target_group
            let reachSelected = targetGroup.some(t => t.measure.includes("reach"))
            const maxDays = this.config_NumberOfConsumptionDaysProgram - 1
            let period = daysBetweenDates(this.$store.getters.getProgramsQuery.start_date, this.$store.getters.getProgramsQuery.end_date)
            if (period > maxDays && reachSelected) isConsumptionPeriodLimitExceededAndReachSelected = true
            return isConsumptionPeriodLimitExceededAndReachSelected
        },
        exceededRecommendedPeriodLimit() {
            const maxDays = this.config_NumberOfConsumptionDaysProgram - 1
            let period = daysBetweenDates(this.$store.getters.getProgramsQueryForAPI.start_date, this.$store.getters.getProgramsQueryForAPI.end_date)
            return period > maxDays
        },
        messageSeeOldData() {
            return `Please click the 'See older data' button to perform searches before the period ${this.config_ToV3ChangeDate}`
        },
        activeTabs() {
            let tabs = [
                { title: "List", condition: true },
                { title: "Reach and Frequency", condition: this.config_ShowReachFrequencyProgram },
            ]
            return tabs.filter(tab => tab.condition)
        }
    },
    methods: {
        async showOrHideSumInTable() {
            this.$store.commit(Mutations.setProgramsSumVisible, !this.$store.getters.getProgramsSumVisible)
        },
        removeGenres() {
            let emptyGenres = {
                genres: [],
                genre_keys: [],
            }
            const updatedQuery = {
                ...this.$store.getters.getProgramsQuery,
                genres: { ...emptyGenres },
            }
            this.$store.commit("setProgramsQuery", updatedQuery)
        },
        removeTargets() {
            const updatedQuery = {
                ...this.$store.getters.getProgramsQuery,
                target_group: [],
            }
            this.$store.commit("setProgramsQuery", updatedQuery)
        },
        onKeyUp(event) {
            if (event.key === "Enter" && this.allModalsClosed) {
                this.onEnter()
            }
        },
        onCancelDialog() {
            this.$bvModal.hide(this.exceededRecommendedPeriodDialogId)
            this.tabIndex = 0
        },
        async handleDownloadSlowQueryModal() {
            await this.exportResult(true)
            this.showSlowQueryModal = false
        },
        handleCancelSlowQueryModal() {
            this.showSlowQueryModal = false
        },

        async handleScheduleReportSubmit(reportname) {
            this.loadingScheduleReport = true
            try {
                this.contentKeys.showConsumtionPeriodProgram = this.config_ShowConsumtionPeriodProgram
                // if we haven't run the query first, we have no content-keys
                if (this.$store.getters.getProgramsResults.data) {
                    this.contentKeys.programs = this.$store.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms
                        .map(p => p.levelTwoPrograms)
                        .flat()
                        .map(p => p.contentKey)
                } else {
                    this.contentKeys.programs = null
                }

                let query = {
                    ...this.$store.getters.getProgramsQueryForAPI,
                    sortBy: this.mainSortBy,
                    sortByDesc: this.mainSortDesc,
                }

                let options = {
                    reportname: reportname,
                    programs: this.contentKeys.programs,
                    showConsumtionPeriodProgram: this.contentKeys.showConsumtionPeriodProgram,
                }

                await this.$store.commit(Mutations.setProgramsQueryForAPI, query)
                await this.$store.dispatch(Actions.executeScheduleQuery, options)

                this.$bvToast.toast("The job is scheduled; you will receive an email when it's completed.", {
                    title: "Scheduled Run",
                    variant: "success",
                    solid: true,
                    autoHideDelay: 5000,
                })
            } catch (error) {
                this.loadingScheduleReport = false
                this.showScheduleReportModal = false
                this.$bvToast.toast("Failed to schedule the report run", {
                    title: "Server Error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000,
                })
            } finally {
                this.loadingScheduleReport = false
                this.showScheduleReportModal = false
            }
        },
        handleScheduleReportCancel() {
            this.showScheduleReportModal = false
        },

        async updateFilterRatingState() {
            // commit change to vuex
            const query = {
                ...this.$store.getters.getProgramsQuery,
                filterByRating: this.filterRatingIsChecked,
            }
            await this.$store.commit(Mutations.setProgramsQuery, query)
        },
        clearAllFields() {
            this.$store.commit(Mutations.setProgramsSearchForPubDate, false)
            this.$store.commit(Mutations.setProgramsGenres, { genres: [], genre_keys: [] })
            let systemToDate = new Date(this.$store.getters.getPublishedToDate)
            this.$store.commit(Mutations.setProgramsQuery, {
                ...this.$store.getters.getProgramsQuery,
                provider_keys: [],
                channels: [],
                columns: this.$store.getters.getProgramsDefaultColumns,
                title: "",
                end_date: dateToyymmddFormat(systemToDate.setDate(systemToDate.getDate())),
                start_date: dateToyymmddFormat(systemToDate.setDate(systemToDate.getDate())),
                pub_end_date: dateToyymmddFormat(systemToDate.setDate(systemToDate.getDate())),
                pub_start_date: dateToyymmddFormat(systemToDate.setDate(systemToDate.getDate() - 1)),
                with_wildcards: true,
                weekdays: [],
                genres: { genres: [], genre_keys: [] },
                target_group: [],
                show_all_content_with_traffic_in_period: false,
                countryTargetGroups: [],
            })
        },
        removeKeyColumn(columnArray) {
            return columnArray.filter(x => !(x.column_type == this.keyColumn.column_type && x.key == this.keyColumn.display_name))
        },
        userClickedExport() {
            // bring up modal
            if (this.tabName === "list") this.$bvModal.show(this.exportDialogId)
            else this.$store.dispatch(Actions.executeProgramsRoFExport)
        },
        selectExportMode() {
            if (this.tabName === "list") {
                let query = {
                    ...this.$store.getters.getProgramsExportQuery,
                    sortBy: this.mainSortBy,
                    sortByDesc: this.mainSortDesc,
                }
                this.$store.commit(Mutations.setProgramsExportQuery, query)
                this.exportResult()
            }
        },
        async exportResult(slowQueryModal = false) {
            this.loadingExportResults = true
            this.contentKeys.showConsumtionPeriodProgram = this.config_ShowConsumtionPeriodProgram
            // if we haven't run the query first, we have no content-keys
            if (this.$store.getters.getProgramsResults.data) {
                this.contentKeys.programs = this.$store.getters.getProgramsResults.data.levelOneProgramsWithLevelTwoPrograms
                    .map(p => p.levelTwoPrograms)
                    .flat()
                    .map(p => p.contentKey)
            } else {
                this.contentKeys.programs = null
            }
            let exportToCsv
            let query = {
                ...this.$store.getters.getProgramsQueryForAPI,
                sortBy: this.mainSortBy,
                sortByDesc: this.mainSortDesc,
            }
            try {
                await this.$store.commit(Mutations.setProgramsQueryForAPI, query)
                let exportQueryParams = {
                    ...this.contentKeys,
                    slowQueryModal,
                }
                exportToCsv = await this.$store.dispatch(Actions.executeExportProgramsQuery, exportQueryParams)
            } catch (error) {
                this.showMsg("Server Error", "Failed to export program", "danger")
                console.error(error)
                this.loadingExportResults = false
                return
            }
            let fileName = ""
            let isResult = this.status === "LOADED"
            let startEndDateText = ""
            if (isResult) startEndDateText = `${query.start_date}_${query.end_date}`
            else startEndDateText = `${this.query.start_date}_${this.query.end_date}`
            if (this.$store.getters.getExcelExportFilePreName == undefined || this.$store.getters.getExcelExportFilePreName == "") {
                fileName = `CROSS-PLATFORM_Program_${startEndDateText}`
            } else {
                fileName = `${this.$store.getters.getExcelExportFilePreName} CROSS-PLATFORM_Program_${startEndDateText}`
            }
            download(exportToCsv, `${fileName}.csv`, null, slowQueryModal)
            this.loadingExportResults = false
        },
        handleTabActivation(newTabIndex) {
            const listIndex = this.findTabIndexByTitle("List")
            const rofIndex = this.findTabIndexByTitle("Reach and Frequency")
            if (newTabIndex === listIndex) {
                this.tabName = "list"
            } else if (newTabIndex === rofIndex) {
                this.tabName = "Reach and Frequency"
                let startDateForApi = this.$store.getters.getProgramsQueryForAPI.start_date
                let newEndDate = dayjs(startDateForApi)
                    .add(this.config_NumberOfConsumptionDaysRecommendedProgram - 1, "d")
                    .format("YYYY-MM-DD")
                this.messageExceededRecommendedPeriod = `
                        The selected period exceeds the maximum limit of
                        ${this.config_NumberOfConsumptionDaysRecommendedProgram} days for <br> reach & frequency.
                        Click OK to proceed and adjust the period to the following: ${startDateForApi} - ${newEndDate}`
                if (this.exceededRecommendedPeriodLimit && !this.hasAcceptedExceededPeriod) {
                    this.$bvModal.show(this.exceededRecommendedPeriodDialogId)
                } else {
                    this.$store.commit(Mutations.setProgramsRoFQuery, {
                        ...this.$store.getters.getProgramsRoFQuery,
                        hasAdjustedTime: false,
                    })
                }
            }
        },
        async acceptExceededRecommendedPeriod() {
            this.hasAcceptedExceededPeriod = true
            this.$bvModal.hide(this.exceededRecommendedPeriodDialogId)
            let startDateForApi = this.$store.getters.getProgramsQueryForAPI.start_date
            let newEndDate = dayjs(startDateForApi)
                .add(this.config_NumberOfConsumptionDaysRecommendedProgram - 1, "d")
                .format("YYYY-MM-DD")
            this.$store.commit(Mutations.setProgramsRoFQuery, {
                ...this.$store.getters.getProgramsRoFQuery,
                endDate: newEndDate,
                hasAdjustedTime: true,
            })
            this.updateRoF()
        },
        async updateRoF() {
            this.$store.commit(Mutations.setProgramsRoFResultsTableData, { ...this.$store.getters.getProgramsRoFResults.tableData, allRofRows: [], roFColumns: [] })
            this.isShowDetailsBtnVisible = false
            await this.$store.dispatch(Actions.executeProgramsRoFQuery)
            this.isShowDetailsBtnVisible = true
            this.showTableDetails = false
        },
        showMsg(title, msg, variant) {
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                solid: true,
                autoHideDelay: 5000,
            })
        },
        async init() {
            // many calls with side effects, start with actions
            try {
                this.checkForFieldChanges = true
                await this.$store.commit(Mutations.setProgramsInitStatus, "LOADING")
                const genres = await this.$store.dispatch(Actions.getProgramsGenres)
                this.loadingFormDataValue = 25
                this.setStartAndEndDate(this.$store.getters.getPublishedToDate)
                await this.getProviders()
                this.loadingFormDataValue = 50
                await this.$store.commit(Mutations.setProgramsGenres, genres)
                // Measures:
                const measures = await this.$store.dispatch(Actions.getProgramsMeasures)
                this.loadingFormDataValue = 75
                this.formFields.target_group.config.measures = [...measures]
                // GENRES:
                const newGenres = Helpers.transformToGenresFromAPIResponse(genres)
                // COLUMNTYPES:
                const columns = await this.$store.dispatch(Actions.getProgramsColumnTypes)
                this.loadingFormDataValue = 100
                this.columnsField.config.options = [...columns]
                await this.$store.commit(Mutations.setProgramsColumnTypes, columns)
                await this.$store.commit(
                    Mutations.setProgramsDefaultColumns,
                    columns.filter(c => c.default_selection).map(c => c.value)
                )
                let updatedQuery = {
                    ...this.$store.getters["getProgramsQuery"],
                    ["columns"]: this.$store.getters.getProgramsDefaultColumns,
                }
                // copy store to local state --
                const newFields = {
                    ...this.formFields,
                    genres: { ...this.formFields.genres, ...newGenres },
                }
                this.$store.commit("setProgramsQuery", updatedQuery)
                // important with await for vue to update our components
                // status must be = LOADED for them to be displayed and they refresh when we set formFields,
                // if they are not displayed then they don't refresh...
                await this.$store.commit(Mutations.setProgramsInitStatus, "LOADED")
                document.addEventListener("keyup", this.onKeyUp)
                if(!this.$store.getters.getProgramsHasSetDefaultQuery) {
                    this.$store.commit(Mutations.setProgramsQueryDefault, updatedQuery);
                    this.$store.commit(Mutations.setProgramsHasSetDefaultQuery, true);
                }
                this.formFields = newFields
            } catch (error) {
                await this.$store.commit(Mutations.setProgramsInitStatus, "FAILED")
            }
        },
        async submitSearch() {
            try {
                this.$store.commit(Mutations.setProgramsSumVisible, false)
                this.tabIndex = 0
                this.tabName = "list"
                this.hasAcceptedExceededPeriod = false
                this.selectAll = false
                if (!this.TargetGroupExists || this.exceededConsumptionPeriodLimitAndReachSelected) return
                validationRules(this)
                const hasError = this.validateForm()
                if (hasError) {
                    scrollToBottom()
                    
                    if (this.formFields?.start_date?.hasError || this.formFields?.end_date?.hasError) {
                        this.formErrors.push("Please fill in the consumption period 'from' and 'to' correctly.")
                    }
                    
                    this.$store.commit(Mutations.setProgramsResults, {
                        status: "VALIDATION_FAILED",
                    })
                    
                    return
                }
                this.$store.commit("setProgramsHaveSelectedRow", false)
                this.tabName = "list"
                // reset the sorting in the main table
                let query = {
                    ...this.$store.getters.getProgramsQueryForAPI,
                    sortBy: "measure_1",
                    sortByDesc: true,
                }
                this.$store.commit(Mutations.setProgramsQueryForAPI, query)
                this.mainSortBy = "measure_1"
                this.mainSortDesc = true
                await this.$store.dispatch(Actions.executeProgramsQuery, this.config_ShowConsumtionPeriodProgram)
                this.checkForFieldChanges = true
                this.$store.commit(Mutations.setProgramsQueryBeforeChange, this.query)
                this.$store.commit(Mutations.setProgramsHasExcludedRow, false)
            } catch {
                this.$store.commit(Mutations.setProgramsResults, {
                    status: "FAILED",
                })
            }
        },
        setStartAndEndDate(publishedToDate) {
            if (!publishedToDate) return
            let previousDate = this.$store.getters.getProgramsQuery
            // only set end date to default date when end date is not changed
            if (!previousDate.end_date) this.$store.commit(Mutations.setProgramsEnddate, this.$store.getters.getPublishedToDate)

            if (!previousDate.start_date) {
                this.$store.commit(Mutations.setProgramsStartdate, this.$store.getters.getPublishedToDate)
                this.$store.commit(Mutations.setProgramsPubStartdate, this.$store.getters.getPublishedToDate)
            }
        },

        async getProviders() {
            this.calledGetProviders = true
            const providerObjects = await this.$store.dispatch(Actions.getProgramsProviders)
            const providers = Object.keys(providerObjects).map(k => providerObjects[k])
            await this.$store.commit(Mutations.setProgramsProviders, providers)

            const sites = providers.filter(x => x.provider_type == "SITE" && x.exists_content)
            const channels = providers
                .filter(x => x.provider_type == "CHANNEL" && x.exists_content)
                .reduce((p, c) => {
                    return { ...p, [c.provider_group]: [...(p[c.provider_group] ?? []), c] }
                }, {})

            const newFields = {
                ...this.formFields,
                providers: { ...this.formFields.providers, sites: sites, channels: channels },
            }

            this.formFields = newFields
            this.calledGetProviders = false
        },
        onEnter() {
            if (!this.disableRunBtn) this.submitSearch()
        },
        resetFailedOrEmptyState() {
            if (this.$store.getters.getProgramsResults.status == "FAILED" || this.$store.getters.getProgramsResults.status == "EMPTY_RESULT") {
                const updatedQuery = {
                    ...this.$store.getters.getProgramsResults,
                    status: "NOT_LOADED",
                }
                this.$store.commit(Mutations.setProgramsResults, updatedQuery)
            }
        },
        async onCancelSeeOldDataDialog() {
            this.$store.commit(Mutations.setProgramsStartdate, this.config_ToV3ChangeDate)
            this.$store.commit(Mutations.setProgramsEnddate, this.config_ToV3ChangeDate)
            this.$store.commit(Mutations.setProgramsPubStartdate, this.config_ToV3ChangeDate)
            this.$store.commit(Mutations.setProgramsPubEnddate, this.config_ToV3ChangeDate)
        },
        onAcceptSeeOldDataDialog() {
            window.location.href = `${this.config_TotalFrontendv1Url}/programs`
        },
        onHideSeeOldDataDialog() {
            this.onCancelSeeOldDataDialog()
        },
        getTabTitleByIndex(index) {
            const tab = this.activeTabs.length > index ? this.activeTabs[index] : null
            return tab ? tab.title : null
        },
        findTabIndexByTitle(title) {
            return this.activeTabs.findIndex(tab => tab.title === title)
        },
    },
}
</script>
<style>
.body {
    background-color: white;
    padding: 20px 30px;
}

.totalRowsStyle {
    margin-left: 10px;
    margin-top: 8px;
}

.label-text {
    font-weight: 713;
    font-size: 11px;
    color: #495057;
    float: left;
    margin-bottom: 0.35rem;
}

.nav-tabs {
    font-size: 80%;
    font-weight: 400;
    align-items: center;
}

.measure-header {
    text-align: right;
    line-height: 1.1;
}
</style>

<style scoped>
>>> .tooltip-inner {
    white-space: nowrap;
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
